import { render, staticRenderFns } from "./SimpleQuestion.vue?vue&type=template&id=6cc18aad&"
import script from "./SimpleQuestion.vue?vue&type=script&lang=js&"
export * from "./SimpleQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports